import React from "react";
import ReactModal from "react-modal";
import { Flex, Text, Link, Box } from "theme-ui";
import Icon from "../Icon";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "8px",
    padding: "0px",
  },
};

function renderExperimental(data) {
  return data.maturity_checklist.experimental.map((obj) => {
    let className = "pop-list-status-none";
    if (obj.passed === true) {
      className = "pop-list-status-green";
    }

    return (
      <Flex key={obj.message} sx={{ alignItems: "baseline", gap: "10px" }}>
        <div className={className} />
        <div>{obj.message}</div>

        {obj.doc_url?.length  ? (
          <Link
            href={obj.doc_url}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Icon
              icon="external-link"
              fontSize="14px"
              sx={{ color: "#7470EB", ml: "8px" }}
            />
            <Text
              sx={{ fontSize: "14px", lineHeight: "24px", color: "#7470EB" }}
            >
              Docs
            </Text>
          </Link>
        ) : null}
      </Flex>
    );
  });
}

function renderBeta(data) {
  return data.maturity_checklist.beta.map((obj) => {
    let className = "pop-list-status-none";
    if (obj.passed === true) {
      className = "pop-list-status-green";
    }

    return (
      <Flex key={obj.message} sx={{ alignItems: "baseline", gap: "10px" }}>
        <div className={className} />
        <div>{obj.message}</div>

        {obj.doc_url?.length  ? (
          <Link
            href={obj.doc_url}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Icon
              icon="external-link"
              fontSize="14px"
              sx={{ color: "#7470EB", ml: "8px" }}
            />
            <Text
              sx={{ fontSize: "14px", lineHeight: "24px", color: "#7470EB" }}
            >
              Docs
            </Text>
          </Link>
        ) : null}
      </Flex>
    );
  });
}

function renderProduction(data) {
  return data.maturity_checklist.production.map((obj) => {
    let className = "pop-list-status-none";
    if (obj.passed === true) {
      className = "pop-list-status-green";
    }

    return (
      <Flex key={obj.message} sx={{ alignItems: "baseline", gap: "10px" }}>
        <div className={className} />
        <div>{obj.message}</div>

        {obj.doc_url?.length  ? (
          <Link
            href={obj.doc_url}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Icon
              icon="external-link"
              fontSize="14px"
              sx={{ color: "#7470EB", ml: "8px" }}
            />

            <Text
              sx={{ fontSize: "14px", lineHeight: "24px", color: "#7470EB" }}
            >
              Docs
            </Text>
          </Link>
        ) : null}
      </Flex>
    );
  });
}

class Popup extends React.PureComponent {
  render() {
    const { popupData, maxValue, value, contribType, toggle } = this.props;
    const closeModal = () => {
      toggle(false);
    };
    const ratio = Math.round(value / maxValue);
    let className;
    if (value === 0) {
      className = "none";
    } else if (value > 0 && ratio < 0.5) {
      className = "red";
    } else if (value === maxValue) {
      className = "green";
    } else {
      className = "orange";
    }
    return (
      <ReactModal
        isOpen={true}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel={contribType}
        shouldCloseOnOverlayClick={true}
      >
        <Flex
          sx={{
            borderBottom: "#F0F0F0 1px solid",
            padding: "16px 24px",
            alignItems: "center",
          }}
        >
          <Flex className={className}>
            <div className="contrib-stat" />
          </Flex>
          <Text
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
              ml: "16px",
            }}
          >
            {contribType}
          </Text>
          <Text sx={{ ml: "12px" }}>
            {value}/{maxValue}
          </Text>
          <Box
            sx={{
              color: "black",
              float: "right",
              fontSize: "24px",
              fontWeight: "bold",
              cursor: "pointer",
              marginLeft: "auto",
            }}
            onClick={() => closeModal()}
          >
            &times;
          </Box>
        </Flex>
        <Flex
          sx={{
            padding: "16px 24px",
            flexDirection: "column",
            gap: "16px",
          }}
        >
            {
                (() => {
                    if (contribType === "Experimental") return renderExperimental(popupData);
                    if (contribType === "Beta") return renderBeta(popupData);
                    return renderProduction(popupData);
                })()
            }
          {/* {contribType === "Experimental"
            ? renderExperimental(popupData)
            : contribType === "Beta"
            ? renderBeta(popupData)
            : renderProduction(popupData)} */}
        </Flex>
      </ReactModal>
    );
  }
}

export default Popup;
